import React from 'react';
import Card from '../../components/Card/Card';
import oops from '../../assets/images/page_not_found.svg';

const Error404 = () => {
  return (
    <>
      <div className="flex flex-col justify-center items-center">
        <Card>
          <div className="flex flex-col justify-center items-center">
            {/* https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif */}
            <img src={oops} alt="404" className="w-1/2" />
            <h1 className="text-2xl font-bold text-gray-800">
              Oops! Page not found
            </h1>
            <p className="text-gray-600">
              The page you are looking for might have been removed had its name
              changed or is temporarily unavailable.
            </p>
          </div>
        </Card>
      </div>
    </>
  );
};

export default Error404;
